"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _UIDropdown = _interopRequireDefault(require("./UIDropdown"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _focusStylesListener = require("../listeners/focusStylesListener");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _renderMultiLevelMenu = require("./utils/renderMultiLevelMenu");

var UIMultiLevelDropdown =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIMultiLevelDropdown, _PureComponent);

  function UIMultiLevelDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIMultiLevelDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIMultiLevelDropdown).call(this, props));
    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIMultiLevelDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._button = (0, _reactDom.findDOMNode)(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open === true && this.props.open === false && (0, _focusStylesListener.isPageInKeyboardMode)()) {
        this._button.focus();
      }
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var options = this.props.options;
      return (0, _renderMultiLevelMenu.renderMenu)(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          __options = _this$props.options,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["options"]);
      return _react.default.createElement(_UIDropdown.default, (0, _extends2.default)({}, rest, {
        animateOnToggle: false,
        Content: this.renderMenu
      }));
    }
  }]);
  return UIMultiLevelDropdown;
}(_react.PureComponent);

UIMultiLevelDropdown.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIDropdown.default.propTypes, ['animateOnMount', 'animateOnToggle', 'Content']), {
  options: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.shape({
    label: _react.PropTypes.node,
    selected: _react.PropTypes.bool,
    options: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.node])
  }), _react.PropTypes.node, _react.PropTypes.arrayOf(_react.PropTypes.shape({
    label: _react.PropTypes.node,
    selected: _react.PropTypes.bool,
    options: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.node])
  }))])).isRequired
});
UIMultiLevelDropdown.defaultProps = (0, _extends2.default)({}, _UIDropdown.default.defaultProps);
UIMultiLevelDropdown.displayName = 'UIMultiLevelDropdown';

var _default = (0, _Controllable.default)(UIMultiLevelDropdown, ['open']);

exports.default = _default;
module.exports = exports.default;